/**
 * Suè — Motion engine (ligero, scroll NATIVO)
 * IntersectionObserver reveals + split text + magnetic + marquee + parallax barato.
 * Sin Lenis ni GSAP → cero secuestro de scroll, máximo rendimiento.
 * Respeta prefers-reduced-motion.
 */

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* 1. Reveals on scroll (fade-up + stagger) */
function initReveals() {
  const targets = document.querySelectorAll('[data-sue-reveal], [data-sue-stagger]');
  if (!targets.length) return;
  if (REDUCED || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.setAttribute('data-sue-in', ''));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (el.hasAttribute('data-sue-stagger')) {
          Array.from(el.children).forEach((child, i) => {
            child.style.setProperty('--sue-stagger-i', i);
          });
        }
        el.setAttribute('data-sue-in', '');
        io.unobserve(el);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
  );
  targets.forEach((el) => io.observe(el));
}

/* 2. Split text por letras — data-sue-split */
function initSplitText() {
  document.querySelectorAll('[data-sue-split]').forEach((el) => {
    if (el.dataset.sueSplitDone === '1') return;
    const text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    el.textContent = '';
    let charIndex = 0;
    text.split(/(\s+)/).forEach((word) => {
      if (/^\s+$/.test(word)) { el.appendChild(document.createTextNode(' ')); return; }
      const wordSpan = document.createElement('span');
      wordSpan.style.display = 'inline-block';
      wordSpan.style.whiteSpace = 'nowrap';
      Array.from(word).forEach((char) => {
        const span = document.createElement('span');
        span.className = 'sue-split-char';
        span.style.setProperty('--sue-char-i', charIndex++);
        span.setAttribute('aria-hidden', 'true');
        span.textContent = char;
        wordSpan.appendChild(span);
      });
      el.appendChild(wordSpan);
    });
    el.dataset.sueSplitDone = '1';
  });
}

/* 3. Magnetic CTAs — solo pointer fino */
function initMagnetic() {
  if (REDUCED || !window.matchMedia('(pointer:fine)').matches) return;
  document.querySelectorAll('[data-sue-magnetic]').forEach((el) => {
    if (el.dataset.sueMagDone === '1') return;
    el.dataset.sueMagDone = '1';
    const strength = parseFloat(el.dataset.sueMagnetic) || 0.3;
    let raf = null;
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left - r.width / 2) * strength;
      const y = (e.clientY - r.top - r.height / 2) * strength;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { el.style.transform = `translate3d(${x}px,${y}px,0)`; });
    });
    el.addEventListener('pointerleave', () => { el.style.transform = ''; });
  });
}

/* 4. Marquee — duplica contenido si hace falta (las secciones ya traen 2 grupos) */
function initMarquees() {
  document.querySelectorAll('.sue-marquee').forEach((m) => {
    const track = m.querySelector('.sue-marquee__track');
    if (!track || track.dataset.sueDup === '1') return;
    track.innerHTML += track.innerHTML;
    track.dataset.sueDup = '1';
  });
}

/* 5. Parallax nativo barato — data-sue-parallax="0.1" */
function initParallax() {
  if (REDUCED) return;
  const els = Array.from(document.querySelectorAll('[data-sue-parallax]'));
  if (!els.length) return;
  let ticking = false;
  function update() {
    const vh = window.innerHeight;
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      const speed = parseFloat(el.dataset.sueParallax) || 0.1;
      const off = ((r.top + r.height / 2) - vh / 2) / vh; // -0.5..0.5
      el.style.transform = `translate3d(0, ${(off * speed * 100).toFixed(2)}px, 0)`;
    });
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
}

function boot() {
  initSplitText();
  initReveals();
  initMagnetic();
  initMarquees();
  initParallax();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
document.addEventListener('shopify:section:load', boot);
